import { Configuration } from "Models/configuration";
import {
    ACTION,
    SetConfigurationAction,
    SET_CONFIGURATION,
} from "Redux/actionTypes";
import { defaultConfig } from "Models/default-config";

export default function reduce(
    state: Configuration = defaultConfig,
    action: ACTION
) {
    switch (action.type) {
        case SET_CONFIGURATION: {
            const {
                payload: { config },
            } = action as SetConfigurationAction;
            return {
                ...state,
                ...config,
            };
        }
        default:
            return state;
    }
}
